// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/dashboard\"},{\"path\":\"/dashboard/advisor\"},{\"path\":\"/dashboard/data\"},{\"path\":\"/dashboard/dividends\"},{\"path\":\"/dashboard/holdings\"},{\"path\":\"/dashboard/holdings/commodities\"},{\"path\":\"/dashboard/holdings/mutual-funds\"},{\"path\":\"/dashboard/settings\"},{\"path\":\"/dashboard/transactions\"},{\"path\":\"/dashboard/transactions/commodities\"},{\"path\":\"/dashboard/transactions/mutual-funds\"},{\"path\":\"/sentry-example-page\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.9";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://a9e051c1e4a2cde02853c46e36d7bc47@o4510228181221376.ingest.us.sentry.io/4510228183384064",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;